export const FeatureName = 'newAccount';
